import React from "react"
import ReactDOM from "react-dom"
import App from "./App"
import * as serviceWorker from "./serviceWorker"
import "react-datepicker/dist/react-datepicker.css"
import Bugsnag from "@bugsnag/js"
import type { Event as BugsnagEvent } from "@bugsnag/js"
import BugsnagPluginReact from "@bugsnag/plugin-react"
import "./libs/analytics"

Bugsnag.start({
	apiKey: "f2f9e3ad85b1138c425a9d5643c6b9b8",
	plugins: [new BugsnagPluginReact()],
	releaseStage: process.env.NODE_ENV !== "production" ? "development" : "production",
	onError: (event: BugsnagEvent) => {
		// Filter noisy non-actionable ResizeObserver loop warnings
		if (event.errors.some((e) => /ResizeObserver loop/.test(e.errorMessage))) {
			event.ignore()
		}
	},
})
// If Chargebee is not initialized, refresh the page
if (!Chargebee) {
	window.location.reload()
}
Chargebee.init({
	site: process.env.REACT_APP_CHARGEBEE_SITE || "busstock",
	enableGATracking: true,
})
const ErrorBoundary = Bugsnag?.getPlugin("react")?.createErrorBoundary(React)

ReactDOM.render(
	ErrorBoundary ? (
		<ErrorBoundary>
			<App />
		</ErrorBoundary>
	) : (
		<App />
	),
	document.getElementById("root"),
)

serviceWorker.unregister()
